import React, { useState, useEffect } from "react";
import TopBar from "./../../components/TopBar";
import "./../css/Alert.css"; // Import custom CSS
import axios from "./../../axios";
import { useParams } from "react-router-dom";

const StaffStudentList = () => {
  const { classid, section } = useParams();
  const [students, setStudents] = useState([
    {
      details: "No Alert Found",
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const staff = JSON.parse(localStorage.getItem("staff"));
        const response = await axios.get(`staff/students/${classid}/${section}`, {
          params: {
            id: staff.id,
          },
        });
        console.log(response.data);
        setStudents(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <TopBar title="Student List" />
      {isLoading ? (
        <div className="alerts-container" style={{ padding: "10px", overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "16px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f4f4f4",
                  textAlign: "left",
                }}
              >
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>
                  <div className="skeleton-text" style={{ width: "60px", height: "20px" }}></div>
                </th>
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>
                  <div className="skeleton-text" style={{ width: "100px", height: "20px" }}></div>
                </th>
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>
                  <div className="skeleton-text" style={{ width: "120px", height: "20px" }}></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(4)].map((_, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "12px" }}>
                    <div className="skeleton-text" style={{ width: "40px", height: "16px" }}></div>
                  </td>
                  <td style={{ padding: "12px" }}>
                    <div className="skeleton-text" style={{ width: "80px", height: "16px" }}></div>
                  </td>
                  <td style={{ padding: "12px" }}>
                    <div className="skeleton-text" style={{ width: "100px", height: "16px" }}></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alerts-container" style={{ padding: "10px", overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "16px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f4f4f4",
                  textAlign: "left",
                }}
              >
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>Roll No</th>
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>Name</th>
                <th style={{ padding: "12px", borderBottom: "1px solid #ddd", fontWeight: "bold" }}>Father's Name</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => (
                <tr
                  key={student.id}
                  style={{
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <td style={{ padding: "12px" }}>{student.roll_no}</td>
                  <td style={{ padding: "12px", fontWeight: "bold" }}>{student.name}</td>
                  <td style={{ padding: "12px" }}>{student.fname}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default StaffStudentList;